<div class="broker-authentication">
  <div class="container-auth">
    <div class="row justify-content-end">
      <div class="close-btn">
        <mat-icon (click)="closeClick()" svgIcon="close"></mat-icon>
        <div class="text">FECHAR</div>
      </div>
    </div>
    <div>
      <div class="box">
        <app-auth-broker></app-auth-broker>
      </div>
    </div>
  </div>
</div>
